<div class="coupon-edit-container px-5 py-2">
    <div class="my-2">
        <h3>{{ 'common.edit' | translate }}</h3>
    </div>
    <hr class="mb-5" />
    <div>
        <form class="k-form k-form-md" [formGroup]="form">
            <div class="d-flex gap-2">
                <div class="col-6">
                    <input hidden type="text" id="partnerId" formControlName="partnerId" class="form-control" />
                    <div class="mb-1 row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="couponCode" class="col-form-label">{{ 'coupon.code' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <input type="text" id="couponCode" formControlName="couponCode" class="form-control" />
                            <app-field-error-message controlName="couponCode"></app-field-error-message>
                        </div>
                    </div>
                    <div class="mb-1 row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="title" class="col-form-label">{{ 'coupon.title' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <input type="text" id="title" formControlName="title" class="form-control" />
                            <app-field-error-message controlName="title"></app-field-error-message>
                        </div>
                    </div>
                    <div class="mb-1 row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="subtitle" class="col-form-label">{{ 'coupon.subtitle' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <input type="text" id="subtitle" formControlName="subtitle" class="form-control" />
                            <app-field-error-message controlName="subtitle"></app-field-error-message>
                        </div>
                    </div>
                    <div class="mb-1 row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="redirectUrl" class="col-form-label">{{ 'coupon.redirect_url' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <input type="text" id="redirectUrl" formControlName="redirectUrl" class="form-control" />
                            <app-field-error-message controlName="redirectUrl"></app-field-error-message>
                        </div>
                    </div>
                    <div class="mb-1 row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="redeemType" class="col-form-label">{{ 'coupon.redeem_type' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <select class="form-control form-select" id="redeemType" formControlName="redeemType">
                                <option value="">{{ 'common.please_select' | translate }}</option>
                                <option *ngFor="let redeemType of couponRedeemTypes" [ngValue]="redeemType.value">
                                    {{ redeemType.text | translate }}
                                </option>
                            </select>
                            <app-field-error-message controlName="redeemType"></app-field-error-message>
                        </div>
                    </div>
                    <div class="mb-1 row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="usageInstructions" class="col-form-label">{{ 'coupon.usage_instructions' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <textarea id="usageInstructions" formControlName="usageInstructions" class="form-control" rows="3"></textarea>
                            <app-field-error-message controlName="usageInstructions"></app-field-error-message>
                        </div>
                    </div>
                    <div class="mb-1 row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="description" class="col-form-label">{{ 'coupon.description' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <textarea id="description" formControlName="description" class="form-control" rows="3"></textarea>
                            <app-field-error-message controlName="description"></app-field-error-message>
                        </div>
                    </div>
                    <div class="mb-1 row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="price" class="col-form-label">{{ 'coupon.price' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <input type="number" id="price" formControlName="price" class="form-control" placeholder="10" />
                            <app-field-error-message controlName="price"></app-field-error-message>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="mb-1 row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="discountPrice" class="col-form-label">{{ 'coupon.discount_price' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <input type="number" id="discountPrice" formControlName="discountPrice" class="form-control" placeholder="10" />
                            <app-field-error-message controlName="discountPrice"></app-field-error-message>
                        </div>
                    </div>
                    <div class="mb-1 row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="discountPercentage" class="col-form-label">{{ 'coupon.discount_percentage' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <input type="text" id="discountPercentage" formControlName="discountPercentage" class="form-control" max="100" mask="separator.0" suffix="%" placeholder="10%" />
                            <app-field-error-message controlName="discountPercentage"></app-field-error-message>
                        </div>
                    </div>
                    <div class="mb-1 row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="transactionFee" class="col-form-label">{{ 'coupon.transaction_fee' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <input type="number" id="transactionFee" formControlName="transactionFee" class="form-control" placeholder="1000 Ft" />
                            <app-field-error-message controlName="transactionFee"></app-field-error-message>
                        </div>
                    </div>
                    <div class="mb-1 row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="count" class="col-form-label">{{ 'coupon.count' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <input type="number" id="count" formControlName="count" class="form-control" placeholder="100 db" />
                            <app-field-error-message controlName="count"></app-field-error-message>
                        </div>
                    </div>
                    <div class="mb-1 row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="expiryDate" class="col-form-label">{{ 'coupon.expired_date' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <input bsDatepicker [bsConfig]="{ isAnimated: true, dateInputFormat: 'MM/DD/YYYY' }" placeholder="MM/DD/YYYY" type="text" id="expiryDate" formControlName="expiryDate" class="form-control" />
                            <app-field-error-message controlName="expiryDate"></app-field-error-message>
                        </div>
                    </div>
                    <div class="mb-1 row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="isTopWeekly" class="col-form-label">{{ 'coupon.is_top_weekly' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <input type="checkbox" id="isTopWeekly" formControlName="isTopWeekly" class="form-check-input" />
                        </div>
                    </div>
                    <div class="mb-1 row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="isCarousel" class="col-form-label">{{ 'coupon.is_carousel' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <input type="checkbox" id="isCarousel" formControlName="isCarousel" class="form-check-input" />
                        </div>
                    </div>
                    <div class="mb-1 row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="maxUsePerUser" class="col-form-label">{{ 'coupon.is_multiple_use' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <input type="checkbox" id="maxUsePerUser" formControlName="maxUsePerUser" class="form-check-input" />
                        </div>
                    </div>
                    <div class="mb-1 row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="isAdultContent" class="col-form-label">{{ 'coupon.is_adult_content' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <input type="checkbox" id="isAdultContent" formControlName="isAdultContent" class="form-check-input" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label class="col-form-label">{{ 'coupon.image' | translate }}<span class="text-danger">*</span> <br>(530x450px)</app-label>
                </div>
                <div class="col-12 col-md-4 col-xl-4">
                    <input type="file" id="couponImage-file-input" (change)="onFileSelected($event, 'couponImage')" class="form-control" accept=".png,.jpg,.jpeg" />
                </div>
                <div class="col-12 col-md-2 col-xl-2">
                    <img class="app-image-fix-width-30px" id="selected-couponImage" />
                </div>
                <div class="col-12 col-md-2 col-xl-2">
                    <button class="btn btn-secondary" (click)="onClearImage('couponImage')">{{ 'common.clear' | translate }}</button>
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label class="col-form-label">{{ 'coupon.gif' | translate }}<br>(530x450px)</app-label>
                </div>
                <div class="col-12 col-md-4 col-xl-4">
                    <input type="file" id="couponGif-file-input" (change)="onFileSelected($event, 'couponGif')" class="form-control" accept=".gif" />
                </div>
                <div class="col-12 col-md-2 col-xl-2">
                    <img class="app-image-fix-width-30px" id="selected-couponGif" />
                </div>
                <div class="col-12 col-md-2 col-xl-2">
                    <button class="btn btn-secondary" (click)="onClearImage('couponGif')">{{ 'common.clear' | translate }}</button>
                </div>
            </div>
            <hr class="my-5" />
            <div class="my-1 row">
                <div class="d-flex justify-content-end align-items-center mb-1 w-100">
                    <div class="d-flex gap-4">
                        <button type="submit" [appClickWait]="onSave" class="btn btn-primary w-100" themeColor="primary">
                            {{ 'common.save' | translate }}
                        </button>
                        <button class="btn btn-secondary w-100" (click)="closeEditPage()">
                            {{ 'common.cancel' | translate }}
                        </button>
                        <button *ngIf="showDeleteButton" type="submit" [appClickWait]="onDeleteConfirm" class="btn btn-warning" themeColor="primary">
                            {{ 'common.inactivate_item' | translate }}
                        </button>
                        <button *ngIf="showUndeleteButton" type="submit" [appClickWait]="onDeleteConfirm" class="btn btn-success" themeColor="primary">
                            {{ 'common.activate_item' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
